#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation DeleteAccountAssignmentAutomation(
    $automation: DeleteClosedLeadAccountTypeAutomationInputFieldInput!
) {
    deleteClosedLeadAccountTypeAutomation(input: {closedLeadAccountTypeAutomation: $automation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
